import React from "react";
import { Typography, Box } from "@material-ui/core";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { formatNota } from "../../utils/formato";

const GraficaEvolucionEstudiante = ({ data, height = 168 }) => {
  const chartData = (data || []).map((d) => ({
    periodo:
      d.periodo != null && String(d.periodo).trim() !== ""
        ? String(d.periodo).trim()
        : [d.anio, d.semestre].every((x) => x != null && String(x).trim() !== "")
          ? `${String(d.anio).trim()}-${String(d.semestre).trim()}`
          : String(d.anio ?? "").trim(),
    puntaje: d.puntaje,
  }));

  return (
    <Box bgcolor="#ffffff" borderRadius={12} boxShadow="0 1px 8px rgba(0, 0, 0, 0.08)" p={1.25}>
      <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 800, color: "#0f172a" }}>
        Evolución del estudiante
      </Typography>
      <Typography variant="caption" color="textSecondary" display="block" style={{ marginBottom: 4, fontSize: 11 }}>
        Media del total por periodo académico (año-semestre, escala 1–5).
      </Typography>
      <Box borderRadius={10} style={{ padding: "4px 0 2px" }}>
        <ResponsiveContainer width="100%" height={height}>
          <LineChart data={chartData} margin={{ top: 6, right: 8, left: 2, bottom: 2 }}>
            <XAxis
              dataKey="periodo"
              type="category"
              allowDuplicatedCategory={false}
              tick={{ fill: "#475569", fontSize: 11, fontWeight: 600 }}
              axisLine={{ stroke: "#cbd5e1" }}
              tickLine={{ stroke: "#cbd5e1" }}
            />
            <YAxis
              domain={[1, 5]}
              ticks={[1, 2, 3, 4, 5]}
              tick={{ fill: "#475569", fontSize: 11, fontWeight: 600 }}
              axisLine={{ stroke: "#cbd5e1" }}
              tickLine={{ stroke: "#cbd5e1" }}
              width={34}
            />
            <Tooltip
              formatter={(value) => formatNota(value, "Sin datos")}
              labelFormatter={(label) => `Periodo ${label}`}
              contentStyle={{
                backgroundColor: "#ffffff",
                border: "none",
                borderRadius: 8,
                color: "#0f172a",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
              labelStyle={{ color: "#64748b", fontWeight: 700 }}
              itemStyle={{ color: "#0f172a", fontWeight: 600 }}
            />
            {chartData.length > 0 && (
              <Line
                type="monotone"
                dataKey="puntaje"
                name="Puntaje total"
                stroke="#1976d2"
                strokeWidth={2.2}
                connectNulls={false}
                dot={(props) => {
                  const { cx, cy, payload } = props;
                  if (payload.puntaje == null || !Number.isFinite(Number(payload.puntaje))) return null;
                  return <circle cx={cx} cy={cy} r={4} fill="#1976d2" stroke="#fff" strokeWidth={1} />;
                }}
                activeDot={{ r: 5 }}
              />
            )}
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default GraficaEvolucionEstudiante;
